export default "/_next/static/chunks/fonts/Syne Bold-b49a330aa8f602bc8fd7ed4ac9291d2c.otf";